// extracted by mini-css-extract-plugin
export default {"wrapper":"confirmation_wrapper__6wwzM","controls":"confirmation_controls__tPpJ6","opacity-transition":"confirmation_opacity-transition__S5Xpb"};